import { render, staticRenderFns } from "./wanalyzer.vue?vue&type=template&id=49af21e4"
import script from "./wanalyzer.vue?vue&type=script&lang=js"
export * from "./wanalyzer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports